import Vue from 'vue';
import Component from 'vue-class-component';
import Router from 'vue-router';
import { Authority } from '../shared/security/authority';

Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
  'beforeRouteUpdate' // for vue-router 2.2+
]);
const Home = () => import('../core/home/home.vue');
const Error = () => import('../core/error/error.vue');
const Register = () => import('../account/register/register.vue');
const Activate = () => import('../account/activate/activate.vue');
const ResetPasswordInit = () => import('../account/reset-password/init/reset-password-init.vue');
const ResetPasswordFinish = () => import('../account/reset-password/finish/reset-password-finish.vue');
const ChangePassword = () => import('../account/change-password/change-password.vue');
const Settings = () => import('../account/settings/settings.vue');
const JhiUserManagementComponent = () => import('../admin/user-management/user-management.vue');
const JhiUserManagementViewComponent = () => import('../admin/user-management/user-management-view.vue');
const JhiUserManagementEditComponent = () => import('../admin/user-management/user-management-edit.vue');
const JhiConfigurationComponent = () => import('../admin/configuration/configuration.vue');
const JhiDocsComponent = () => import('../admin/docs/docs.vue');
const JhiHealthComponent = () => import('../admin/health/health.vue');
const JhiLogsComponent = () => import('../admin/logs/logs.vue');
const JhiAuditsComponent = () => import('../admin/audits/audits.vue');
const SchedulerControllerComponent = () => import('../admin/scheduler-controller/scheduler-controller.vue');
const JhiMetricsComponent = () => import('../admin/metrics/metrics.vue');
/* tslint:disable */
// prettier-ignore
const Company = () => import('../entities/company/company.vue');
// prettier-ignore
const CompanyUpdate = () => import('../entities/company/company-update.vue');
// prettier-ignore
const CompanyDetails = () => import('../entities/company/company-details.vue');
// prettier-ignore
const CheckListType = () => import('../entities/check-list-type/check-list-type.vue');
// prettier-ignore
const CheckListTypeUpdate = () => import('../entities/check-list-type/check-list-type-update.vue');
// prettier-ignore
const CheckListTypeDetails = () => import('../entities/check-list-type/check-list-type-details.vue');
// prettier-ignore
const CheckListTpl = () => import('../entities/check-list-tpl/check-list-tpl.vue');
// prettier-ignore
const CheckListTplUpdate = () => import('../entities/check-list-tpl/check-list-tpl-update.vue');
// prettier-ignore
const CheckListTplDetails = () => import('../entities/check-list-tpl/check-list-tpl-details.vue');
// prettier-ignore
const SectionTpl = () => import('../entities/section-tpl/section-tpl.vue');
// prettier-ignore
const SectionTplUpdate = () => import('../entities/section-tpl/section-tpl-update.vue');
// prettier-ignore
const SectionTplDetails = () => import('../entities/section-tpl/section-tpl-details.vue');
// prettier-ignore
const QuestionTpl = () => import('../entities/question-tpl/question-tpl.vue');
// prettier-ignore
const QuestionTplUpdate = () => import('../entities/question-tpl/question-tpl-update.vue');
// prettier-ignore
const QuestionTplDetails = () => import('../entities/question-tpl/question-tpl-details.vue');
// prettier-ignore
const QuestionTplType = () => import('../entities/question-tpl-type/question-tpl-type.vue');
// prettier-ignore
const QuestionTplTypeUpdate = () => import('../entities/question-tpl-type/question-tpl-type-update.vue');
// prettier-ignore
const QuestionTplTypeDetails = () => import('../entities/question-tpl-type/question-tpl-type-details.vue');
// prettier-ignore
const AnswerTpl = () => import('../entities/answer-tpl/answer-tpl.vue');
// prettier-ignore
const AnswerTplUpdate = () => import('../entities/answer-tpl/answer-tpl-update.vue');
// prettier-ignore
const AnswerTplDetails = () => import('../entities/answer-tpl/answer-tpl-details.vue');
// prettier-ignore
const SubmissionStatus = () => import('../entities/submission-status/submission-status.vue');
// prettier-ignore
const SubmissionStatusUpdate = () => import('../entities/submission-status/submission-status-update.vue');
// prettier-ignore
const SubmissionStatusDetails = () => import('../entities/submission-status/submission-status-details.vue');
// prettier-ignore
const SubmissionHeader = () => import('../entities/submission-header/submission-header.vue');
// prettier-ignore
const SubmissionHeaderUpdate = () => import('../entities/submission-header/submission-header-update.vue');
// prettier-ignore
const SubmissionHeaderDetails = () => import('../entities/submission-header/submission-header-details.vue');
// prettier-ignore
const SubmissionRow = () => import('../entities/submission-row/submission-row.vue');
// prettier-ignore
const SubmissionRowUpdate = () => import('../entities/submission-row/submission-row-update.vue');
// prettier-ignore
const SubmissionRowDetails = () => import('../entities/submission-row/submission-row-details.vue');
// prettier-ignore
const JudgementType = () => import('../entities/judgement-type/judgement-type.vue');
// prettier-ignore
const JudgementTypeUpdate = () => import('../entities/judgement-type/judgement-type-update.vue');
// prettier-ignore
const JudgementTypeDetails = () => import('../entities/judgement-type/judgement-type-details.vue');
// prettier-ignore
const Judgement = () => import('../entities/judgement/judgement.vue');
// prettier-ignore
const JudgementUpdate = () => import('../entities/judgement/judgement-update.vue');
// prettier-ignore
const JudgementDetails = () => import('../entities/judgement/judgement-details.vue');
// prettier-ignore
const SubmissionJudgement = () => import('../entities/submission-judgement/submission-judgement.vue');
// prettier-ignore
const SubmissionJudgementUpdate = () => import('../entities/submission-judgement/submission-judgement-update.vue');
// prettier-ignore
const SubmissionJudgementDetails = () => import('../entities/submission-judgement/submission-judgement-details.vue');
// prettier-ignore
const Laboratory = () => import('../entities/laboratory/laboratory.vue');
// prettier-ignore
const LaboratoryUpdate = () => import('../entities/laboratory/laboratory-update.vue');
// prettier-ignore
const LaboratoryDetails = () => import('../entities/laboratory/laboratory-details.vue');
// prettier-ignore
const Supplier = () => import('../entities/supplier/supplier.vue');
// prettier-ignore
const SupplierUpdate = () => import('../entities/supplier/supplier-update.vue');
// prettier-ignore
const SupplierDetails = () => import('../entities/supplier/supplier-details.vue');
// prettier-ignore
const SupplierLightDetail = () => import('../entities/supplier/supplier-details-light.vue');
// prettier-ignore
const SupplierFamily = () => import('../entities/supplier-family/supplier-family.vue');
// prettier-ignore
const SupplierFamilyUpdate = () => import('../entities/supplier-family/supplier-family-update.vue');
// prettier-ignore
const SupplierFamilyDetails = () => import('../entities/supplier-family/supplier-family-details.vue');
// prettier-ignore
const SupplierFamilyType = () => import('../entities/supplier-family-type/supplier-family-type.vue');
// prettier-ignore
const SupplierFamilyTypeUpdate = () => import('../entities/supplier-family-type/supplier-family-type-update.vue');
// prettier-ignore
const SupplierFamilyTypeDetails = () => import('../entities/supplier-family-type/supplier-family-type-details.vue');
// prettier-ignore
const RiskLevelType = () => import('../entities/risk-level-type/risk-level-type.vue');
// prettier-ignore
const RiskLevelTypeUpdate = () => import('../entities/risk-level-type/risk-level-type-update.vue');
// prettier-ignore
const RiskLevelTypeDetails = () => import('../entities/risk-level-type/risk-level-type-details.vue');
// prettier-ignore
const AnalysisHeader = () => import('../entities/analysis-header/analysis-header.vue');
// prettier-ignore
const AnalysisHeaderUpdate = () => import('../entities/analysis-header/analysis-header-update.vue');
// prettier-ignore
const AnalysisHeaderDetails = () => import('../entities/analysis-header/analysis-header-details.vue');
// prettier-ignore
const AnalysisRow = () => import('../entities/analysis-row/analysis-row.vue');
// prettier-ignore
const AnalysisRowUpdate = () => import('../entities/analysis-row/analysis-row-update.vue');
// prettier-ignore
const AnalysisRowDetails = () => import('../entities/analysis-row/analysis-row-details.vue');
// prettier-ignore
const GesDocType = () => import('../entities/ges-doc-type/ges-doc-type.vue');
// prettier-ignore
const GesDocTypeUpdate = () => import('../entities/ges-doc-type/ges-doc-type-update.vue');
// prettier-ignore
const GesDocTypeDetails = () => import('../entities/ges-doc-type/ges-doc-type-details.vue');
// prettier-ignore
const GesDoc = () => import('../entities/ges-doc/ges-doc.vue');
// prettier-ignore
const GesDocUpdate = () => import('../entities/ges-doc/ges-doc-update.vue');
// prettier-ignore
const GesDocDetails = () => import('../entities/ges-doc/ges-doc-details.vue');
// prettier-ignore
const MailTemplate = () => import('../entities/mail-template/mail-template.vue');
// prettier-ignore
const MailTemplateUpdate = () => import('../entities/mail-template/mail-template-update.vue');
// prettier-ignore
const MailTemplateDetails = () => import('../entities/mail-template/mail-template-details.vue');
// prettier-ignore
const MailMatrix = () => import('../entities/mail-matrix/mail-matrix.vue');
// prettier-ignore
const MailMatrixUpdate = () => import('../entities/mail-matrix/mail-matrix-update.vue');
// prettier-ignore
const MailMatrixDetails = () => import('../entities/mail-matrix/mail-matrix-details.vue');
// prettier-ignore
const AuditMail = () => import('../entities/audit-mail/audit-mail.vue');
// prettier-ignore
const AuditMailUpdate = () => import('../entities/audit-mail/audit-mail-update.vue');
// prettier-ignore
const AuditMailDetails = () => import('../entities/audit-mail/audit-mail-details.vue');
// prettier-ignore
const AuditMailType = () => import('../entities/audit-mail-type/audit-mail-type.vue');
// prettier-ignore
const AuditMailTypeUpdate = () => import('../entities/audit-mail-type/audit-mail-type-update.vue');
// prettier-ignore
const AuditMailTypeDetails = () => import('../entities/audit-mail-type/audit-mail-type-details.vue');
// prettier-ignore
const SubmissionStatusType = () => import('../entities/submission-status-type/submission-status-type.vue');
// prettier-ignore
const SubmissionStatusTypeUpdate = () => import('../entities/submission-status-type/submission-status-type-update.vue');
// prettier-ignore
const SubmissionStatusTypeDetails = () => import('../entities/submission-status-type/submission-status-type-details.vue');
// prettier-ignore
const Insignia = () => import('../entities/insignia/insignia.vue');
// prettier-ignore
const InsigniaUpdate = () => import('../entities/insignia/insignia-update.vue');
// prettier-ignore
const InsigniaDetails = () => import('../entities/insignia/insignia-details.vue');
// prettier-ignore
const Associate = () => import('../entities/associate/associate.vue');
// prettier-ignore
const AssociateUpdate = () => import('../entities/associate/associate-update.vue');
// prettier-ignore
const AssociateDetails = () => import('../entities/associate/associate-details.vue');
// prettier-ignore
const ProductFamily = () => import('../entities/product-family/product-family.vue');
// prettier-ignore
const ProductFamilyUpdate = () => import('../entities/product-family/product-family-update.vue');
// prettier-ignore
const ProductFamilyDetails = () => import('../entities/product-family/product-family-details.vue');
// prettier-ignore
const ProductSupplier = () => import('../entities/product-supplier/product-supplier.vue');
// prettier-ignore
const ProductSupplierUpdate = () => import('../entities/product-supplier/product-supplier-update.vue');
// prettier-ignore
const ProductSupplierDetails = () => import('../entities/product-supplier/product-supplier-details.vue');
// prettier-ignore
const Product = () => import('../entities/product/product.vue');
// prettier-ignore
const ProductUpdate = () => import('../entities/product/product-update.vue');
// prettier-ignore
const ProductDetails = () => import('../entities/product/product-details.vue');
// prettier-ignore
const ReType = () => import('../entities/re-type/re-type.vue');
// prettier-ignore
const ReTypeUpdate = () => import('../entities/re-type/re-type-update.vue');
// prettier-ignore
const ReTypeDetails = () => import('../entities/re-type/re-type-details.vue');
// prettier-ignore
const UseType = () => import('../entities/use-type/use-type.vue');
// prettier-ignore
const UseTypeUpdate = () => import('../entities/use-type/use-type-update.vue');
// prettier-ignore
const UseTypeDetails = () => import('../entities/use-type/use-type-details.vue');
// prettier-ignore
const Re = () => import('../entities/re/re.vue');
// prettier-ignore
const ReUpdate = () => import('../entities/re/re-update.vue');
// prettier-ignore
const ReDetails = () => import('../entities/re/re-details.vue');
// prettier-ignore
const Inspector = () => import('../entities/inspector/inspector.vue');
// prettier-ignore
const InspectorUpdate = () => import('../entities/inspector/inspector-update.vue');
// prettier-ignore
const InspectorDetails = () => import('../entities/inspector/inspector-details.vue');
// prettier-ignore
const UserExtra = () => import('../entities/user-extra/user-extra.vue');
// prettier-ignore
const UserExtraUpdate = () => import('../entities/user-extra/user-extra-update.vue');
// prettier-ignore
const UserExtraDetails = () => import('../entities/user-extra/user-extra-details.vue');
// prettier-ignore
const ContactType = () => import('../entities/contact-type/contact-type.vue');
// prettier-ignore
const ContactTypeUpdate = () => import('../entities/contact-type/contact-type-update.vue');
// prettier-ignore
const ContactTypeDetails = () => import('../entities/contact-type/contact-type-details.vue');
// prettier-ignore
const Contact = () => import('../entities/contact/contact.vue');
// prettier-ignore
const ContactUpdate = () => import('../entities/contact/contact-update.vue');
// prettier-ignore
const ContactDetails = () => import('../entities/contact/contact-details.vue');
// prettier-ignore
const ProductAssociate = () => import('../entities/product-associate/product-associate.vue');
// prettier-ignore
const ProductAssociateUpdate = () => import('../entities/product-associate/product-associate-update.vue');
// prettier-ignore
const ProductAssociateDetails = () => import('../entities/product-associate/product-associate-details.vue');
// prettier-ignore
const Ean = () => import('../entities/ean/ean.vue');
// prettier-ignore
const EanUpdate = () => import('../entities/ean/ean-update.vue');
// prettier-ignore
const EanDetails = () => import('../entities/ean/ean-details.vue');
// prettier-ignore
const Buyer = () => import('../entities/buyer/buyer.vue');
// prettier-ignore
const BuyerUpdate = () => import('../entities/buyer/buyer-update.vue');
// prettier-ignore
const BuyerDetails = () => import('../entities/buyer/buyer-details.vue');
// prettier-ignore
const Warehouse = () => import('../entities/warehouse/warehouse.vue');
// prettier-ignore
const WarehouseUpdate = () => import('../entities/warehouse/warehouse-update.vue');
// prettier-ignore
const WarehouseDetails = () => import('../entities/warehouse/warehouse-details.vue');
// prettier-ignore
const ReportJudgement = () => import('../entities/report-judgement/report-judgement.vue');
// prettier-ignore
const ReportJudgementUpdate = () => import('../entities/report-judgement/report-judgement-update.vue');
// prettier-ignore
const ReportJudgementDetails = () => import('../entities/report-judgement/report-judgement-details.vue');
// prettier-ignore
const ReportSupplier = () => import('../entities/custom-view/report-supplier/report-supplier.vue');
// jhipster-needle-add-entity-to-router-import - JHipster will import entities to the router here

const CheckListStepContainer = () => import('../workflow/check-list/check-list-step-container.vue');

const UtenzeFornitori = () => import('../report/utenze-fornitori/utenze-fornitori.vue');

const ChecklistFornitori = () => import('../report/checklist-fornitori/checklist-fornitori.vue');

const FlawType = () => import('../entities/flaw-type/flaw-type.vue');

const FlawTypeDetail = () => import('../entities/flaw-type/flaw-type-details.vue');

const FlawTypeUpdate = () => import('../entities/flaw-type/flaw-type-update.vue');

const CompanyFlaw = () => import('../entities/company-flaw/company-flaw.vue');

const CompanyFlawDetail = () => import('../entities/company-flaw/company-flaw-details.vue');

const CompanyFlawUpdate = () => import('../entities/company-flaw/company-flaw-update.vue');

const SelfassesmentReport = () => import('../report/selfassesment-report/selfassesment-report.vue');

Vue.use(Router);

// prettier-ignore
export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/forbidden',
      name: 'Forbidden',
      component: Error,
      meta: { error403: true }
    },
    {
      path: '/not-found',
      name: 'NotFound',
      component: Error,
      meta: { error404: true }
    },
    {
      path: '/register',
      name: 'Register',
      component: Register
    },
    {
      path: '/account/activate',
      name: 'Activate',
      component: Activate
    },
    {
      path: '/account/reset/request',
      name: 'ResetPasswordInit',
      component: ResetPasswordInit
    },
    {
      path: '/account/reset/finish',
      name: 'ResetPasswordFinish',
      component: ResetPasswordFinish
    },
    {
      path: '/account/password',
      name: 'ChangePassword',
      component: ChangePassword
    },
    {
      path: '/account/settings',
      name: 'Settings',
      component: Settings,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/admin/user-management',
      name: 'JhiUser',
      component: JhiUserManagementComponent,
      meta: { authorities: [Authority.ADMIN,Authority.FORIA] }
    },
    {
      path: '/admin/user-management/new',
      name: 'JhiUserCreate',
      component: JhiUserManagementEditComponent,
      meta: { authorities: [Authority.ADMIN,Authority.FORIA] }
    },
    {
      path: '/admin/user-management/:userId/edit',
      name: 'JhiUserEdit',
      component: JhiUserManagementEditComponent,
      meta: { authorities: [Authority.ADMIN,Authority.FORIA] }
    },
    {
      path: '/admin/user-management/:userId/view',
      name: 'JhiUserView',
      component: JhiUserManagementViewComponent,
      meta: { authorities: [Authority.ADMIN,Authority.FORIA] }
    },
    {
      path: '/admin/docs',
      name: 'JhiDocsComponent',
      component: JhiDocsComponent,
      meta: { authorities: [Authority.ADMIN] }
    },
    {
      path: '/admin/audits',
      name: 'JhiAuditsComponent',
      component: JhiAuditsComponent,
      meta: { authorities: [Authority.ADMIN] }
    },
    {
      path: '/admin/scheduler-controller',
      name: 'SchedulerControllerComponent',
      component: SchedulerControllerComponent,
      meta: { authorities: [Authority.ADMIN] }
    },
    {
      path: '/admin/jhi-health',
      name: 'JhiHealthComponent',
      component: JhiHealthComponent,
      meta: { authorities: [Authority.ADMIN] }
    },
    {
      path: '/admin/logs',
      name: 'JhiLogsComponent',
      component: JhiLogsComponent,
      meta: { authorities: [Authority.ADMIN] }
    },
    {
      path: '/admin/jhi-metrics',
      name: 'JhiMetricsComponent',
      component: JhiMetricsComponent,
      meta: { authorities: [Authority.ADMIN] }
    },
    {
      path: '/admin/jhi-configuration',
      name: 'JhiConfigurationComponent',
      component: JhiConfigurationComponent,
      meta: { authorities: [Authority.ADMIN] }
    }
    ,
    {
      path: '/company',
      name: 'Company',
      component: Company,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.COMPANY] }
    },
    {
      path: '/company/new',
      name: 'CompanyCreate',
      component: CompanyUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.COMPANY] }
    },
    {
      path: '/company/:companyId/edit',
      name: 'CompanyEdit',
      component: CompanyUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.COMPANY] }
    },
    {
      path: '/company/:companyId/view',
      name: 'CompanyView',
      component: CompanyDetails,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.COMPANY] }
    }
    ,
    {
      path: '/check-list-type',
      name: 'CheckListType',
      component: CheckListType,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/check-list-type/new',
      name: 'CheckListTypeCreate',
      component: CheckListTypeUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/check-list-type/:checkListTypeId/edit',
      name: 'CheckListTypeEdit',
      component: CheckListTypeUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/check-list-type/:checkListTypeId/view',
      name: 'CheckListTypeView',
      component: CheckListTypeDetails,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    }
    ,
    {
      path: '/check-list-tpl',
      name: 'CheckListTpl',
      component: CheckListTpl,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/check-list-tpl/new',
      name: 'CheckListTplCreate',
      component: CheckListTplUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/check-list-tpl/:checkListTplId/edit',
      name: 'CheckListTplEdit',
      component: CheckListTplUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/check-list-tpl/:checkListTplId/view',
      name: 'CheckListTplView',
      component: CheckListTplDetails,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    }
    ,
    {
      path: '/section-tpl',
      name: 'SectionTpl',
      component: SectionTpl,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/section-tpl/new',
      name: 'SectionTplCreate',
      component: SectionTplUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/section-tpl/:sectionTplId/edit',
      name: 'SectionTplEdit',
      component: SectionTplUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/section-tpl/:sectionTplId/view',
      name: 'SectionTplView',
      component: SectionTplDetails,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    }
    ,
    {
      path: '/question-tpl',
      name: 'QuestionTpl',
      component: QuestionTpl,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/question-tpl/new',
      name: 'QuestionTplCreate',
      component: QuestionTplUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/question-tpl/:questionTplId/edit',
      name: 'QuestionTplEdit',
      component: QuestionTplUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/question-tpl/:questionTplId/view',
      name: 'QuestionTplView',
      component: QuestionTplDetails,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    }
    ,
    {
      path: '/question-tpl-type',
      name: 'QuestionTplType',
      component: QuestionTplType,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/question-tpl-type/new',
      name: 'QuestionTplTypeCreate',
      component: QuestionTplTypeUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/question-tpl-type/:questionTplTypeId/edit',
      name: 'QuestionTplTypeEdit',
      component: QuestionTplTypeUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/question-tpl-type/:questionTplTypeId/view',
      name: 'QuestionTplTypeView',
      component: QuestionTplTypeDetails,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    }
    ,
    {
      path: '/answer-tpl',
      name: 'AnswerTpl',
      component: AnswerTpl,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/answer-tpl/new',
      name: 'AnswerTplCreate',
      component: AnswerTplUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/answer-tpl/:answerTplId/edit',
      name: 'AnswerTplEdit',
      component: AnswerTplUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/answer-tpl/:answerTplId/view',
      name: 'AnswerTplView',
      component: AnswerTplDetails,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    }
    ,
    {
      path: '/submission-status',
      name: 'SubmissionStatus',
      component: SubmissionStatus,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/submission-status/new',
      name: 'SubmissionStatusCreate',
      component: SubmissionStatusUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/submission-status/:submissionStatusId/edit',
      name: 'SubmissionStatusEdit',
      component: SubmissionStatusUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/submission-status/:submissionStatusId/view',
      name: 'SubmissionStatusView',
      component: SubmissionStatusDetails,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    }
    ,
    {
      path: '/submission-header',
      name: 'SubmissionHeader',
      component: SubmissionHeader,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.COMPANY, Authority.INSPECTOR] }
    },
    {
      path: '/submission-header/new',
      name: 'SubmissionHeaderCreate',
      component: SubmissionHeaderUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.COMPANY] }
    },
    {
      path: '/submission-header/:submissionHeaderId/edit',
      name: 'SubmissionHeaderEdit',
      component: SubmissionHeaderUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.COMPANY] }
    },
    {
      path: '/submission-header/:submissionHeaderId/view',
      name: 'SubmissionHeaderView',
      component: SubmissionHeaderDetails,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.COMPANY] }
    }
    ,
    {
      path: '/submission-row',
      name: 'SubmissionRow',
      component: SubmissionRow,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.COMPANY] }
    },
    {
      path: '/submission-row/new',
      name: 'SubmissionRowCreate',
      component: SubmissionRowUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.COMPANY] }
    },
    {
      path: '/submission-row/:submissionRowId/edit',
      name: 'SubmissionRowEdit',
      component: SubmissionRowUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.COMPANY] }
    },
    {
      path: '/submission-row/:submissionRowId/view',
      name: 'SubmissionRowView',
      component: SubmissionRowDetails,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.COMPANY] }
    }
    ,
    {
      path: '/judgement-type',
      name: 'JudgementType',
      component: JudgementType,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/judgement-type/new',
      name: 'JudgementTypeCreate',
      component: JudgementTypeUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/judgement-type/:judgementTypeId/edit',
      name: 'JudgementTypeEdit',
      component: JudgementTypeUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/judgement-type/:judgementTypeId/view',
      name: 'JudgementTypeView',
      component: JudgementTypeDetails,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    }
    ,
    {
      path: '/judgement',
      name: 'Judgement',
      component: Judgement,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/judgement/new',
      name: 'JudgementCreate',
      component: JudgementUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/judgement/:judgementId/edit',
      name: 'JudgementEdit',
      component: JudgementUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/judgement/:judgementId/view',
      name: 'JudgementView',
      component: JudgementDetails,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.LAB] }
    }
    ,
    {
      path: '/submission-judgement',
      name: 'SubmissionJudgement',
      component: SubmissionJudgement,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/submission-judgement/new',
      name: 'SubmissionJudgementCreate',
      component: SubmissionJudgementUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.LAB] }
    },
    {
      path: '/submission-judgement/:submissionJudgementId/edit',
      name: 'SubmissionJudgementEdit',
      component: SubmissionJudgementUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.LAB] }
    },
    {
      path: '/submission-judgement/:submissionJudgementId/view',
      name: 'SubmissionJudgementView',
      component: SubmissionJudgementDetails,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    }
    ,
    {
      path: '/laboratory',
      name: 'Laboratory',
      component: Laboratory,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/laboratory/new',
      name: 'LaboratoryCreate',
      component: LaboratoryUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/laboratory/:laboratoryId/edit',
      name: 'LaboratoryEdit',
      component: LaboratoryUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/laboratory/:laboratoryId/view',
      name: 'LaboratoryView',
      component: LaboratoryDetails,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    }
    ,
    {
      path: '/supplier',
      name: 'Supplier',
      component: Supplier,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.COMPANY] }
    },
    {
      path: '/supplier/new',
      name: 'SupplierCreate',
      component: SupplierUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.COMPANY] }
    },
    {
      path: '/supplier/:supplierId/edit',
      name: 'SupplierEdit',
      component: SupplierUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.COMPANY,Authority.SUPPLIER] }
    },
    {
      path: '/supplier/:supplierId/view',
      name: 'SupplierView',
      component: SupplierDetails,
      children: [
        {path: 'survey', component: SubmissionHeader, meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.COMPANY,Authority.SUPPLIER] }},
        {path: 'inspection', component: SubmissionHeader, meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.COMPANY,Authority.SUPPLIER] }},
        {path: 'teleaudit', component: SubmissionHeader, meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.COMPANY,Authority.SUPPLIER] }},
        {path: 'analysis', component: AnalysisHeader, meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.COMPANY,Authority.SUPPLIER] }},
        {path: 'globalMarket', component: SubmissionHeader, meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.COMPANY,Authority.SUPPLIER] }},
        {path: 'maintenance', component: SubmissionHeader, meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.COMPANY,Authority.SUPPLIER] }},
        {path: 'technicalSpecification', component: SubmissionHeader, meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.COMPANY,Authority.SUPPLIER] }},
        {path: 'address', component: Contact, meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.COMPANY,Authority.SUPPLIER] }},
        {path: 'report', component: ReportSupplier, meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.COMPANY,Authority.SUPPLIER] }}
      ],
      meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.COMPANY,Authority.SUPPLIER] }
    },
    {
      path: '/analysis-header/:analysisHeaderId/view',
      name: 'AnalysisHeaderView',
      component: AnalysisHeaderDetails,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.COMPANY,Authority.LAB,Authority.SUPPLIER] },
      children: [
        {path: 'analysis-row', component: AnalysisRow, meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.COMPANY,Authority.LAB,Authority.SUPPLIER] } },
        {path: 'submission-judgement/new', component: SubmissionJudgementUpdate, meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.COMPANY,Authority.LAB,Authority.SUPPLIER] } },
        {path: 'submission-judgement/:submissionJudgementId/edit', component: SubmissionJudgementUpdate, meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.COMPANY,Authority.LAB,Authority.SUPPLIER] } }
      ]
    }
    ,
    {
      path: '/supplier-light/:supplierId/view',
      name: 'SupplierLightDetail',
      component: SupplierLightDetail,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.SUPPLIER,Authority.COMPANY] },
      children: [
        {path: 'survey', component: SubmissionHeader, meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.SUPPLIER,Authority.COMPANY] } },
        {path: 'inspection', component: SubmissionHeader, meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.SUPPLIER,Authority.COMPANY] }},
        {path: 'teleaudit', component: SubmissionHeader, meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.SUPPLIER,Authority.COMPANY] }},
        {path: 'analysis', component: AnalysisHeader, meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.SUPPLIER,Authority.COMPANY] }},
        {path: 'globalMarket', component: SubmissionHeader, meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.SUPPLIER,Authority.COMPANY] }},
        {path: 'technicalSpecification', component: SubmissionHeader, meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.SUPPLIER,Authority.COMPANY] }},
        {path: 'address', component: Contact, meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.SUPPLIER,Authority.COMPANY] }}
      ]
    },
    {
      path: '/supplier/:supplierId/view/:checkListType/submission-header/:submissionHeaderId/view',
      name: 'SubmissionHeaderViewSupplierChild',
      component: SubmissionHeaderDetails,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.SUPPLIER,Authority.COMPANY] },
    },
    {
      path: '/supplier/:supplierId/view/:checkListType/submission-header/:submissionHeaderId/edit',
      name: 'SubmissionHeaderEditSupplierChild',
      component: SubmissionHeaderUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.SUPPLIER,Authority.COMPANY] },
    },
    {
      path: '/supplier/:supplierId/view/:checkListType/submission-header/:submissionHeaderId/view/submission-row/:submissionRowId/view',
      name: 'SubmissionRowViewSupplierChild',
      component: SubmissionRowDetails,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.SUPPLIER,Authority.COMPANY] },
    },
    {
      path: '/supplier/:supplierId/view/:checkListType/submission-header/:submissionHeaderId/view/submission-row/:submissionRowId/edit',
      name: 'SubmissionRowEditSupplierChild',
      component: SubmissionRowUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.SUPPLIER,Authority.COMPANY] },
    },
    {
      path: '/supplier-family',
      name: 'SupplierFamily',
      component: SupplierFamily,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/supplier-family/new',
      name: 'SupplierFamilyCreate',
      component: SupplierFamilyUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/supplier-family/:supplierFamilyId/edit',
      name: 'SupplierFamilyEdit',
      component: SupplierFamilyUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/supplier-family/:supplierFamilyId/view',
      name: 'SupplierFamilyView',
      component: SupplierFamilyDetails,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    }
    ,
    {
      path: '/supplier-family-type',
      name: 'SupplierFamilyType',
      component: SupplierFamilyType,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/supplier-family-type/new',
      name: 'SupplierFamilyTypeCreate',
      component: SupplierFamilyTypeUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/supplier-family-type/:supplierFamilyTypeId/edit',
      name: 'SupplierFamilyTypeEdit',
      component: SupplierFamilyTypeUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/supplier-family-type/:supplierFamilyTypeId/view',
      name: 'SupplierFamilyTypeView',
      component: SupplierFamilyTypeDetails,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    }
    ,
    {
      path: '/risk-level-type',
      name: 'RiskLevelType',
      component: RiskLevelType,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/risk-level-type/new',
      name: 'RiskLevelTypeCreate',
      component: RiskLevelTypeUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/risk-level-type/:riskLevelTypeId/edit',
      name: 'RiskLevelTypeEdit',
      component: RiskLevelTypeUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/risk-level-type/:riskLevelTypeId/view',
      name: 'RiskLevelTypeView',
      component: RiskLevelTypeDetails,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    }
    ,
    {
      path: '/analysis-header',
      name: 'AnalysisHeader',
      component: AnalysisHeader,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.LAB,Authority.SUPPLIER] }
    },
    {
      path: '/analysis-header/new',
      name: 'AnalysisHeaderCreate',
      component: AnalysisHeaderUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.LAB] }
    },
    {
      path: '/analysis-header/:analysisHeaderId/edit',
      name: 'AnalysisHeaderEdit',
      component: AnalysisHeaderUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.LAB] }
    },
    {
      path: '/analysis-header/:analysisHeaderId/view',
      name: 'AnalysisHeaderView',
      component: AnalysisHeaderDetails,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.LAB,Authority.SUPPLIER] }
    }
    ,
    {
      path: '/analysis-row',
      name: 'AnalysisRow',
      component: AnalysisRow,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.LAB] }
    },
    {
      path: '/analysis-row/new',
      name: 'AnalysisRowCreate',
      component: AnalysisRowUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.LAB] }
    },
    {
      path: '/analysis-row/:analysisRowId/edit',
      name: 'AnalysisRowEdit',
      component: AnalysisRowUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.LAB] }
    },
    {
      path: '/analysis-row/:analysisRowId/view',
      name: 'AnalysisRowView',
      component: AnalysisRowDetails,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.LAB] }
    },
    {
      path: '/supplier',
      name: 'Supplier',
      component: Supplier,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/supplier/new',
      name: 'SupplierCreate',
      component: SupplierUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/supplier/:supplierId/edit',
      name: 'SupplierEdit',
      component: SupplierUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/supplier/:supplierId/view',
      name: 'SupplierView',
      component: SupplierDetails,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/workflow',
      name: 'CheckListWorkflow',
      component: CheckListStepContainer,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.SUPPLIER, Authority.INSPECTOR] }
    }
    ,
    {
      path: '/ges-doc-type',
      name: 'GesDocType',
      component: GesDocType,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/ges-doc-type/new',
      name: 'GesDocTypeCreate',
      component: GesDocTypeUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/ges-doc-type/:gesDocTypeId/edit',
      name: 'GesDocTypeEdit',
      component: GesDocTypeUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/ges-doc-type/:gesDocTypeId/view',
      name: 'GesDocTypeView',
      component: GesDocTypeDetails,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    }
    ,
    {
      path: '/ges-doc',
      name: 'GesDoc',
      component: GesDoc,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/ges-doc/new',
      name: 'GesDocCreate',
      component: GesDocUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/ges-doc/:gesDocId/edit',
      name: 'GesDocEdit',
      component: GesDocUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/ges-doc/:gesDocId/view',
      name: 'GesDocView',
      component: GesDocDetails,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    }
    ,
    {
      path: '/mail-template',
      name: 'MailTemplate',
      component: MailTemplate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/mail-template/new',
      name: 'MailTemplateCreate',
      component: MailTemplateUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/mail-template/:mailTemplateId/edit',
      name: 'MailTemplateEdit',
      component: MailTemplateUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/mail-template/:mailTemplateId/view',
      name: 'MailTemplateView',
      component: MailTemplateDetails,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    }
    ,
    {
      path: '/mail-matrix',
      name: 'MailMatrix',
      component: MailMatrix,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/mail-matrix/new',
      name: 'MailMatrixCreate',
      component: MailMatrixUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/mail-matrix/:mailMatrixId/edit',
      name: 'MailMatrixEdit',
      component: MailMatrixUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/mail-matrix/:mailMatrixId/view',
      name: 'MailMatrixView',
      component: MailMatrixDetails,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    }
    ,
    {
      path: '/audit-mail',
      name: 'AuditMail',
      component: AuditMail,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/audit-mail/new',
      name: 'AuditMailCreate',
      component: AuditMailUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/audit-mail/:auditMailId/edit',
      name: 'AuditMailEdit',
      component: AuditMailUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/audit-mail/:auditMailId/view',
      name: 'AuditMailView',
      component: AuditMailDetails,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    }
    ,
    {
      path: '/audit-mail-type',
      name: 'AuditMailType',
      component: AuditMailType,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/audit-mail-type/new',
      name: 'AuditMailTypeCreate',
      component: AuditMailTypeUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/audit-mail-type/:auditMailTypeId/edit',
      name: 'AuditMailTypeEdit',
      component: AuditMailTypeUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/audit-mail-type/:auditMailTypeId/view',
      name: 'AuditMailTypeView',
      component: AuditMailTypeDetails,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    }
    ,
    {
      path: '/submission-status-type',
      name: 'SubmissionStatusType',
      component: SubmissionStatusType,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/submission-status-type/new',
      name: 'SubmissionStatusTypeCreate',
      component: SubmissionStatusTypeUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/submission-status-type/:submissionStatusTypeId/edit',
      name: 'SubmissionStatusTypeEdit',
      component: SubmissionStatusTypeUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/submission-status-type/:submissionStatusTypeId/view',
      name: 'SubmissionStatusTypeView',
      component: SubmissionStatusTypeDetails,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    }
    ,
    {
      path: '/submission-status',
      name: 'SubmissionStatus',
      component: SubmissionStatus,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/submission-status/new',
      name: 'SubmissionStatusCreate',
      component: SubmissionStatusUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/submission-status/:submissionStatusId/edit',
      name: 'SubmissionStatusEdit',
      component: SubmissionStatusUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/submission-status/:submissionStatusId/view',
      name: 'SubmissionStatusView',
      component: SubmissionStatusDetails,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    }
    ,
    {
      path: '/check-list-type',
      name: 'CheckListType',
      component: CheckListType,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/check-list-type/new',
      name: 'CheckListTypeCreate',
      component: CheckListTypeUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/check-list-type/:checkListTypeId/edit',
      name: 'CheckListTypeEdit',
      component: CheckListTypeUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/check-list-type/:checkListTypeId/view',
      name: 'CheckListTypeView',
      component: CheckListTypeDetails,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    }
    ,
    {
      path: '/insignia',
      name: 'Insignia',
      component: Insignia,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.COMPANY] }
    },
    {
      path: '/insignia/new',
      name: 'InsigniaCreate',
      component: InsigniaUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.COMPANY] }
    },
    {
      path: '/insignia/:insigniaId/edit',
      name: 'InsigniaEdit',
      component: InsigniaUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.COMPANY] }
    },
    {
      path: '/insignia/:insigniaId/view',
      name: 'InsigniaView',
      component: InsigniaDetails,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.COMPANY] }
    }
    ,
    {
      path: '/associate',
      name: 'Associate',
      component: Associate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.COMPANY] }
    },
    {
      path: '/associate/new',
      name: 'AssociateCreate',
      component: AssociateUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.COMPANY] }
    },
    {
      path: '/associate/:associateId/edit',
      name: 'AssociateEdit',
      component: AssociateUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.COMPANY] }
    },
    {
      path: '/associate/:associateId/view',
      name: 'AssociateView',
      component: AssociateDetails,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.COMPANY] }
    }
    ,
    {
      path: '/company',
      name: 'Company',
      component: Company,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.COMPANY] }
    },
    {
      path: '/company/new',
      name: 'CompanyCreate',
      component: CompanyUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.COMPANY] }
    },
    {
      path: '/company/:companyId/edit',
      name: 'CompanyEdit',
      component: CompanyUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.COMPANY] }
    },
    {
      path: '/company/:companyId/view',
      name: 'CompanyView',
      component: CompanyDetails,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.COMPANY] }
    }
    ,
    {
      path: '/product-family',
      name: 'ProductFamily',
      component: ProductFamily,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/product-family/new',
      name: 'ProductFamilyCreate',
      component: ProductFamilyUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/product-family/:productFamilyId/edit',
      name: 'ProductFamilyEdit',
      component: ProductFamilyUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/product-family/:productFamilyId/view',
      name: 'ProductFamilyView',
      component: ProductFamilyDetails,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    }
    ,
    {
      path: '/product-supplier',
      name: 'ProductSupplier',
      component: ProductSupplier,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.COMPANY,Authority.SUPPLIER] }
    },
    {
      path: '/product-supplier/new',
      name: 'ProductSupplierCreate',
      component: ProductSupplierUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.COMPANY,Authority.SUPPLIER] }
    },
    {
      path: '/product-supplier/:productSupplierId/edit',
      name: 'ProductSupplierEdit',
      component: ProductSupplierUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.COMPANY,Authority.SUPPLIER] }
    },
    {
      path: '/product-supplier/:productSupplierId/view',
      name: 'ProductSupplierView',
      component: ProductSupplierDetails,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.FORIA,Authority.COMPANY,Authority.SUPPLIER] }
    }
    ,
    {
      path: '/product',
      name: 'Product',
      component: Product,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.LAB,Authority.FORIA] }
    },
    {
      path: '/product/new',
      name: 'ProductCreate',
      component: ProductUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.FORIA] }
    },
    {
      path: '/product/:productId/edit',
      name: 'ProductEdit',
      component: ProductUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.FORIA] }
    },
    {
      path: '/product/:productId/view',
      name: 'ProductView',
      component: ProductDetails,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN,Authority.FORIA] }
    }
    ,
    {
      path: '/supplier',
      name: 'Supplier',
      component: Supplier,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/supplier/new',
      name: 'SupplierCreate',
      component: SupplierUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/supplier/:supplierId/edit',
      name: 'SupplierEdit',
      component: SupplierUpdate,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/supplier/:supplierId/view',
      name: 'SupplierView',
      component: SupplierDetails,
      meta: { authorities: [Authority.FORIA,Authority.ADMIN] }
    }
    ,
    {
      path: '/re-type',
      name: 'ReType',
      component: ReType,
      meta: { authorities: [Authority.USER,Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/re-type/new',
      name: 'ReTypeCreate',
      component: ReTypeUpdate,
      meta: { authorities: [Authority.USER,Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/re-type/:reTypeId/edit',
      name: 'ReTypeEdit',
      component: ReTypeUpdate,
      meta: { authorities: [Authority.USER,Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/re-type/:reTypeId/view',
      name: 'ReTypeView',
      component: ReTypeDetails,
      meta: { authorities: [Authority.USER,Authority.FORIA,Authority.ADMIN] }
    }
    ,
    {
      path: '/use-type',
      name: 'UseType',
      component: UseType,
      meta: { authorities: [Authority.USER,Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/use-type/new',
      name: 'UseTypeCreate',
      component: UseTypeUpdate,
      meta: { authorities: [Authority.USER,Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/use-type/:useTypeId/edit',
      name: 'UseTypeEdit',
      component: UseTypeUpdate,
      meta: { authorities: [Authority.USER,Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/use-type/:useTypeId/view',
      name: 'UseTypeView',
      component: UseTypeDetails,
      meta: { authorities: [Authority.USER,Authority.FORIA,Authority.ADMIN] }
    }
    ,
    {
      path: '/re',
      name: 'Re',
      component: Re,
      meta: { authorities: [Authority.USER,Authority.FORIA,Authority.ADMIN,Authority.COMPANY] }
    },
    {
      path: '/re/new',
      name: 'ReCreate',
      component: ReUpdate,
      meta: { authorities: [Authority.USER,Authority.FORIA,Authority.ADMIN,Authority.COMPANY] }
    },
    {
      path: '/re/:reId/edit',
      name: 'ReEdit',
      component: ReUpdate,
      meta: { authorities: [Authority.USER,Authority.FORIA,Authority.ADMIN,Authority.COMPANY] }
    },
    {
      path: '/re/:reId/view',
      name: 'ReView',
      component: ReDetails,
      meta: { authorities: [Authority.USER,Authority.FORIA,Authority.ADMIN,Authority.COMPANY] }
    }
    ,
    {
      path: '/insignia',
      name: 'Insignia',
      component: Insignia,
      meta: { authorities: [Authority.USER,Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/insignia/new',
      name: 'InsigniaCreate',
      component: InsigniaUpdate,
      meta: { authorities: [Authority.USER,Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/insignia/:insigniaId/edit',
      name: 'InsigniaEdit',
      component: InsigniaUpdate,
      meta: { authorities: [Authority.USER,Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/insignia/:insigniaId/view',
      name: 'InsigniaView',
      component: InsigniaDetails,
      meta: { authorities: [Authority.USER,Authority.FORIA,Authority.ADMIN] }
    }
    ,
    {
      path: '/product',
      name: 'Product',
      component: Product,
      meta: { authorities: [Authority.USER,Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/product/new',
      name: 'ProductCreate',
      component: ProductUpdate,
      meta: { authorities: [Authority.USER,Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/product/:productId/edit',
      name: 'ProductEdit',
      component: ProductUpdate,
      meta: { authorities: [Authority.USER,Authority.FORIA,Authority.ADMIN] }
    },
    {
      path: '/product/:productId/view',
      name: 'ProductView',
      component: ProductDetails,
      meta: { authorities: [Authority.USER,Authority.FORIA,Authority.ADMIN] }
    }
    ,
    {
      path: '/mail-matrix',
      name: 'MailMatrix',
      component: MailMatrix,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/mail-matrix/new',
      name: 'MailMatrixCreate',
      component: MailMatrixUpdate,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/mail-matrix/:mailMatrixId/edit',
      name: 'MailMatrixEdit',
      component: MailMatrixUpdate,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/mail-matrix/:mailMatrixId/view',
      name: 'MailMatrixView',
      component: MailMatrixDetails,
      meta: { authorities: [Authority.USER] }
    }
    ,
    {
      path: '/audit-mail',
      name: 'AuditMail',
      component: AuditMail,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/audit-mail/new',
      name: 'AuditMailCreate',
      component: AuditMailUpdate,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/audit-mail/:auditMailId/edit',
      name: 'AuditMailEdit',
      component: AuditMailUpdate,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/audit-mail/:auditMailId/view',
      name: 'AuditMailView',
      component: AuditMailDetails,
      meta: { authorities: [Authority.USER] }
    }
    ,
    {
      path: '/inspector',
      name: 'Inspector',
      component: Inspector,
      meta: { authorities: [Authority.FORIA] }
    },
    {
      path: '/inspector/new',
      name: 'InspectorCreate',
      component: InspectorUpdate,
      meta: { authorities: [Authority.FORIA] }
    },
    {
      path: '/inspector/:inspectorId/edit',
      name: 'InspectorEdit',
      component: InspectorUpdate,
      meta: { authorities: [Authority.FORIA] }
    },
    {
      path: '/inspector/:inspectorId/view',
      name: 'InspectorView',
      component: InspectorDetails,
      meta: { authorities: [Authority.FORIA] }
    }
    ,
    {
      path: '/user-extra',
      name: 'UserExtra',
      component: UserExtra,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/user-extra/new',
      name: 'UserExtraCreate',
      component: UserExtraUpdate,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/user-extra/:userExtraId/edit',
      name: 'UserExtraEdit',
      component: UserExtraUpdate,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/user-extra/:userExtraId/view',
      name: 'UserExtraView',
      component: UserExtraDetails,
      meta: { authorities: [Authority.USER] }
    }
    ,
    {
      path: '/contact-type',
      name: 'ContactType',
      component: ContactType,
      meta: { authorities: [Authority.USER,Authority.COMPANY] }
    },
    {
      path: '/contact-type/new',
      name: 'ContactTypeCreate',
      component: ContactTypeUpdate,
      meta: { authorities: [Authority.USER,Authority.COMPANY] }
    },
    {
      path: '/contact-type/:contactTypeId/edit',
      name: 'ContactTypeEdit',
      component: ContactTypeUpdate,
      meta: { authorities: [Authority.USER,Authority.COMPANY] }
    },
    {
      path: '/contact-type/:contactTypeId/view',
      name: 'ContactTypeView',
      component: ContactTypeDetails,
      meta: { authorities: [Authority.USER,Authority.COMPANY] }
    }
    ,
    {
      path: '/contact',
      name: 'Contact',
      component: Contact,
      meta: { authorities: [Authority.USER,Authority.COMPANY,Authority.FORIA,Authority.ADMIN,Authority.SUPPLIER] }
    },
    {
      path: '/contact/new',
      name: 'ContactCreate',
      component: ContactUpdate,
      meta: { authorities: [Authority.USER,Authority.COMPANY,Authority.FORIA,Authority.ADMIN,Authority.SUPPLIER] }
    },
    {
      path: '/contact/:contactId/edit',
      name: 'ContactEdit',
      component: ContactUpdate,
      meta: { authorities: [Authority.USER,Authority.COMPANY,Authority.FORIA,Authority.ADMIN,Authority.SUPPLIER] }
    },
    {
      path: '/contact/:contactId/view',
      name: 'ContactView',
      component: ContactDetails,
      meta: { authorities: [Authority.USER,Authority.COMPANY,Authority.FORIA,Authority.ADMIN,Authority.SUPPLIER] }
    }
    ,
    {
      path: '/supplier',
      name: 'Supplier',
      component: Supplier,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/supplier/new',
      name: 'SupplierCreate',
      component: SupplierUpdate,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/supplier/:supplierId/edit',
      name: 'SupplierEdit',
      component: SupplierUpdate,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/supplier/:supplierId/view',
      name: 'SupplierView',
      component: SupplierDetails,
      meta: { authorities: [Authority.USER] }
    }
    ,
    {
      path: '/product-family',
      name: 'ProductFamily',
      component: ProductFamily,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/product-family/new',
      name: 'ProductFamilyCreate',
      component: ProductFamilyUpdate,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/product-family/:productFamilyId/edit',
      name: 'ProductFamilyEdit',
      component: ProductFamilyUpdate,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/product-family/:productFamilyId/view',
      name: 'ProductFamilyView',
      component: ProductFamilyDetails,
      meta: { authorities: [Authority.USER] }
    }
    ,
    {
      path: '/associate',
      name: 'Associate',
      component: Associate,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/associate/new',
      name: 'AssociateCreate',
      component: AssociateUpdate,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/associate/:associateId/edit',
      name: 'AssociateEdit',
      component: AssociateUpdate,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/associate/:associateId/view',
      name: 'AssociateView',
      component: AssociateDetails,
      meta: { authorities: [Authority.USER] }
    }
    ,
    {
      path: '/re',
      name: 'Re',
      component: Re,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/re/new',
      name: 'ReCreate',
      component: ReUpdate,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/re/:reId/edit',
      name: 'ReEdit',
      component: ReUpdate,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/re/:reId/view',
      name: 'ReView',
      component: ReDetails,
      meta: { authorities: [Authority.USER] }
    }
    ,
    {
      path: '/company',
      name: 'Company',
      component: Company,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/company/new',
      name: 'CompanyCreate',
      component: CompanyUpdate,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/company/:companyId/edit',
      name: 'CompanyEdit',
      component: CompanyUpdate,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/company/:companyId/view',
      name: 'CompanyView',
      component: CompanyDetails,
      meta: { authorities: [Authority.USER] }
    }
    ,
    {
      path: '/insignia',
      name: 'Insignia',
      component: Insignia,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/insignia/new',
      name: 'InsigniaCreate',
      component: InsigniaUpdate,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/insignia/:insigniaId/edit',
      name: 'InsigniaEdit',
      component: InsigniaUpdate,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/insignia/:insigniaId/view',
      name: 'InsigniaView',
      component: InsigniaDetails,
      meta: { authorities: [Authority.USER] }
    }
    ,
    {
      path: '/product',
      name: 'Product',
      component: Product,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/product/new',
      name: 'ProductCreate',
      component: ProductUpdate,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/product/:productId/edit',
      name: 'ProductEdit',
      component: ProductUpdate,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/product/:productId/view',
      name: 'ProductView',
      component: ProductDetails,
      meta: { authorities: [Authority.USER] }
    }
    ,
    {
      path: '/product-associate',
      name: 'ProductAssociate',
      component: ProductAssociate,
      meta: { authorities: [Authority.USER,Authority.COMPANY,Authority.COMPANY,Authority.FORIA] }
    },
    {
      path: '/product-associate/new',
      name: 'ProductAssociateCreate',
      component: ProductAssociateUpdate,
      meta: { authorities: [Authority.USER,Authority.COMPANY,Authority.COMPANY,Authority.FORIA] }
    },
    {
      path: '/product-associate/:productAssociateId/edit',
      name: 'ProductAssociateEdit',
      component: ProductAssociateUpdate,
      meta: { authorities: [Authority.USER,Authority.COMPANY,Authority.COMPANY,Authority.FORIA] }
    },
    {
      path: '/product-associate/:productAssociateId/view',
      name: 'ProductAssociateView',
      component: ProductAssociateDetails,
      meta: { authorities: [Authority.USER,Authority.COMPANY,Authority.FORIA] }
    }
    ,
    {
      path: '/ean',
      name: 'Ean',
      component: Ean,
      meta: { authorities: [Authority.USER,Authority.COMPANY,Authority.FORIA] }
    },
    {
      path: '/ean/new',
      name: 'EanCreate',
      component: EanUpdate,
      meta: { authorities: [Authority.USER,Authority.COMPANY,Authority.FORIA] }
    },
    {
      path: '/ean/:eanId/edit',
      name: 'EanEdit',
      component: EanUpdate,
      meta: { authorities: [Authority.USER,Authority.COMPANY,Authority.FORIA] }
    },
    {
      path: '/ean/:eanId/view',
      name: 'EanView',
      component: EanDetails,
      meta: { authorities: [Authority.USER,Authority.COMPANY,Authority.FORIA] }
    }
    ,
    {
      path: '/product-supplier',
      name: 'ProductSupplier',
      component: ProductSupplier,
      meta: { authorities: [Authority.USER,Authority.COMPANY,Authority.FORIA,Authority.SUPPLIER] }
    },
    {
      path: '/product-supplier/new',
      name: 'ProductSupplierCreate',
      component: ProductSupplierUpdate,
      meta: { authorities: [Authority.USER,Authority.COMPANY,Authority.FORIA,Authority.SUPPLIER] }
    },
    {
      path: '/product-supplier/:productSupplierId/edit',
      name: 'ProductSupplierEdit',
      component: ProductSupplierUpdate,
      meta: { authorities: [Authority.USER,Authority.COMPANY,Authority.FORIA,Authority.SUPPLIER] }
    },
    {
      path: '/product-supplier/:productSupplierId/view',
      name: 'ProductSupplierView',
      component: ProductSupplierDetails,
      meta: { authorities: [Authority.USER,Authority.COMPANY,Authority.FORIA,Authority.SUPPLIER] }
    }
    ,
    {
      path: '/submission-judgement',
      name: 'SubmissionJudgement',
      component: SubmissionJudgement,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/submission-judgement/new',
      name: 'SubmissionJudgementCreate',
      component: SubmissionJudgementUpdate,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/submission-judgement/:submissionJudgementId/edit',
      name: 'SubmissionJudgementEdit',
      component: SubmissionJudgementUpdate,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/submission-judgement/:submissionJudgementId/view',
      name: 'SubmissionJudgementView',
      component: SubmissionJudgementDetails,
      meta: { authorities: [Authority.USER] }
    }
    ,
    {
      path: '/buyer',
      name: 'Buyer',
      component: Buyer,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/buyer/new',
      name: 'BuyerCreate',
      component: BuyerUpdate,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/buyer/:buyerId/edit',
      name: 'BuyerEdit',
      component: BuyerUpdate,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/buyer/:buyerId/view',
      name: 'BuyerView',
      component: BuyerDetails,
      meta: { authorities: [Authority.USER] }
    }
    ,
    {
      path: '/companyFlaw',
      name: 'CompanyFlaw',
      component: CompanyFlaw,
      meta: { authorities: [Authority.USER, Authority.FORIA] }
    },
    {
      path: '/companyFlaw/new',
      name: 'CompanyFlawCreate',
      component: CompanyFlawUpdate,
      meta: { authorities: [Authority.USER, Authority.FORIA] }
    },
    {
      path: '/companyFlaw/:companyFlawId/edit',
      name: 'CompanyFlawEdit',
      component: CompanyFlawUpdate,
      meta: { authorities: [Authority.USER, Authority.FORIA] }
    },
    {
      path: '/companyFlaw/:companyFlawId/view',
      name: 'CompanyFlawView',
      component: CompanyFlawDetail,
      meta: { authorities: [Authority.USER, Authority.FORIA] }
    },
    {
      path: '/flaw-type',
      name: 'FlawType',
      component: FlawType,
      meta: { authorities: [Authority.USER, Authority.FORIA] }
    },
    {
      path: '/flawType/new',
      name: 'FlawTypeCreate',
      component: FlawTypeUpdate,
      meta: { authorities: [Authority.USER, Authority.FORIA] }
    },
    {
      path: '/flawType/:flawTypeId/edit',
      name: 'FlawTypeEdit',
      component: FlawTypeUpdate,
      meta: { authorities: [Authority.USER, Authority.FORIA] }
    },
    {
      path: '/flawType/:flawTypeId/view',
      name: 'FlawTypeView',
      component: FlawTypeDetail,
      meta: { authorities: [Authority.USER, Authority.FORIA] }
    },
    {
      path: '/warehouse',
      name: 'Warehouse',
      component: Warehouse,
      meta: { authorities: [Authority.USER, Authority.FORIA] }
    },
    {
      path: '/warehouse/new',
      name: 'WarehouseCreate',
      component: WarehouseUpdate,
      meta: { authorities: [Authority.USER, Authority.FORIA] }
    },
    {
      path: '/warehouse/:warehouseId/edit',
      name: 'WarehouseEdit',
      component: WarehouseUpdate,
      meta: { authorities: [Authority.USER, Authority.FORIA] }
    },
    {
      path: '/warehouse/:warehouseId/view',
      name: 'WarehouseView',
      component: WarehouseDetails,
      meta: { authorities: [Authority.USER, Authority.FORIA] }
    }
    ,
    {
      path: '/submission-header',
      name: 'SubmissionHeader',
      component: SubmissionHeader,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/submission-header/new',
      name: 'SubmissionHeaderCreate',
      component: SubmissionHeaderUpdate,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/submission-header/:submissionHeaderId/edit',
      name: 'SubmissionHeaderEdit',
      component: SubmissionHeaderUpdate,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/submission-header/:submissionHeaderId/view',
      name: 'SubmissionHeaderView',
      component: SubmissionHeaderDetails,
      meta: { authorities: [Authority.USER] }
    }
    ,
    {
      path: '/inspector',
      name: 'Inspector',
      component: Inspector,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/inspector/new',
      name: 'InspectorCreate',
      component: InspectorUpdate,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/inspector/:inspectorId/edit',
      name: 'InspectorEdit',
      component: InspectorUpdate,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/inspector/:inspectorId/view',
      name: 'InspectorView',
      component: InspectorDetails,
      meta: { authorities: [Authority.USER] }
    }
    ,
    {
      path: '/check-list-type',
      name: 'CheckListType',
      component: CheckListType,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/check-list-type/new',
      name: 'CheckListTypeCreate',
      component: CheckListTypeUpdate,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/check-list-type/:checkListTypeId/edit',
      name: 'CheckListTypeEdit',
      component: CheckListTypeUpdate,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/check-list-type/:checkListTypeId/view',
      name: 'CheckListTypeView',
      component: CheckListTypeDetails,
      meta: { authorities: [Authority.USER] }
    }
    ,
    {
      path: '/report-judgement',
      name: 'ReportJudgement',
      component: ReportJudgement,
      meta: { authorities: [Authority.USER, Authority.FORIA] }
    },
    {
      path: '/report-judgement/new',
      name: 'ReportJudgementCreate',
      component: ReportJudgementUpdate,
      meta: { authorities: [Authority.USER, Authority.FORIA] }
    },
    {
      path: '/report-judgement/:reportJudgementId/edit',
      name: 'ReportJudgementEdit',
      component: ReportJudgementUpdate,
      meta: { authorities: [Authority.USER, Authority.FORIA] }
    },
    {
      path: '/report-judgement/:reportJudgementId/view',
      name: 'ReportJudgementView',
      component: ReportJudgementDetails,
      meta: { authorities: [Authority.USER, Authority.FORIA] }
    }
    ,
    {
      path: '/ges-doc',
      name: 'GesDoc',
      component: GesDoc,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/ges-doc/new',
      name: 'GesDocCreate',
      component: GesDocUpdate,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/ges-doc/:gesDocId/edit',
      name: 'GesDocEdit',
      component: GesDocUpdate,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/ges-doc/:gesDocId/view',
      name: 'GesDocView',
      component: GesDocDetails,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/checklist-fornitori',
      name: 'ChecklistFornitori',
      component: ChecklistFornitori,
      meta: { authorities: [Authority.FORIA] }
    },
    {
      path: '/utenze-fornitori',
      name: 'UtenzeFornitori',
      component: UtenzeFornitori,
      meta: { authorities: [Authority.FORIA] }
    },
    {
      path: '/selfassesment-report',
      name: 'SelfassesmentReport',
      component: SelfassesmentReport,
      meta: { authorities: [Authority.FORIA, Authority.ADMIN, Authority.COMPANY] }
    }
    // jhipster-needle-add-entity-to-router - JHipster will add entities to the router here
  ]
});
